import React, { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { useAuth, login } from "../../auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import {
  faAngleLeft,
  faUnlockAlt,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  FormCheck,
  Container,
  InputGroup,
  Modal,
  Image,
} from "@themesberg/react-bootstrap";

import SigninLogo from "../../assets/img/signin_logo_new.png";

import { Routes } from "../../routes";

const Deactivated = ({ id }) => {
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h6">
          <FormattedMessage id="notAllowed" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <FormattedMessage id="notAllowedUser" />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button href={Routes.Signin.path} variant="secondary">
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Unconfirmed = ({ id }) => {
  const onResend = () => {
    fetch(`api/resend?id=${id}`, {
      method: "get",
    })
      .then((resp) => resp.json)
      .then((resp) => {
        if (resp.resend) {
          console.log("success!");
        }
      });
  };
  return (
    <Modal as={Modal.Dialog} centered show>
      <Modal.Header>
        <Modal.Title className="h6">
          <FormattedMessage id="notVerifiedEmail" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <FormattedMessage id="notCompletedyetEmail" />
          <br />
          <FormattedMessage id="linkCompleted" />
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onResend}>
          <FormattedMessage id="notRecevied" />
        </Button>
        <Button href={Routes.Signin.path} variant="secondary">
          <FormattedMessage id="confirm" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default () => {
  const [input, setInput] = useState({ id: "", password: "" });
  const [unconfirmed, setUnconfirmed] = useState(false);
  const [deactivated, setDeactivated] = useState(false);
  const [msg, setMsg] = useState("");
  const history = useHistory();
  const [logged] = useAuth();
  const { id, password } = input;

  useEffect(() => {
    if (logged) {
      history.push(Routes.Admin.path);
      return;
    }
  }, [history, logged]);

  const onChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    fetch(process.env.REACT_APP_API_URL + "/api/login", {
      method: "post",
      body: JSON.stringify({
        id,
        password,
      }),
    })
      .then((resp) => {
        if (resp.status === 401) {
          setMsg("아이디 또는 비밀번호가 일치하지 않습니다.");
        }
        return resp.json();
      })
      .then((resp) => {
        console.log(resp);
        if (resp.access_token) {
          setMsg("");
          if (resp.access_token === "0000") {
            setUnconfirmed(true);
          } else if (resp.access_token === "4444") {
            setDeactivated(true);
          } else {
            localStorage.setItem('accessID', id);
            login(resp);
          }
        }
      });
  };

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <p className="text-center">
            <Card.Link
              as={Link}
              to={Routes.Defalut.path}
              className="text-gray-700"
            >
              <FontAwesomeIcon icon={faAngleLeft} className="me-2" />{" "}
              <FormattedMessage id="goHome" />
            </Card.Link>
          </p>
          <Row className="justify-content-center form-bg-image">
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <Image src={SigninLogo} draggable="false" width='80%' height='80%' />
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">
                    <FormattedMessage id="login" />
                  </h3>
                </div>
                <Form className="mt-4">
                  <Form.Group id="id" className="mb-4">
                    <Form.Label>
                      <FormattedMessage id="id" />
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                      <Form.Control
                        autoFocus
                        required
                        type="text"
                        placeholder="example"
                        value={id}
                        name="id"
                        onChange={onChange}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="password" />
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type="password"
                          placeholder="Password"
                          value={password}
                          name="password"
                          onChange={onChange}
                        />
                      </InputGroup>
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <Form.Check type="checkbox">
                        <FormCheck.Input id="defaultCheck5" className="me-2" />
                        <FormCheck.Label
                          htmlFor="defaultCheck5"
                          className="mb-0"
                        >
                          <FormattedMessage id="saveID" />
                        </FormCheck.Label>
                      </Form.Check>
                      <div>
                        <Card.Link className="small text-end" href="/forgot-id">
                          <FormattedMessage id="findID" />
                        </Card.Link>
                        <Card.Link
                          className="small text-end"
                          href="/forgot-password"
                        >
                          <FormattedMessage id="findPassword" />
                        </Card.Link>
                      </div>
                    </div>
                  </Form.Group>
                  {msg && <p className="text-danger">{msg}</p>}
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    onClick={onSubmit}
                  >
                    <FormattedMessage id="login" />
                  </Button>
                </Form>

                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    <FormattedMessage id="noneUser" />
                    <Card.Link
                      as={Link}
                      to={Routes.Signup.path}
                      className="fw-bold"
                    >
                      {<FormattedMessage id="signup" />}
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {unconfirmed && <Unconfirmed id={id} />}
      {deactivated && <Deactivated id={id} />}
    </main>
  );
};
